(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-tabs"] && !Shopify.designMode) return;
  try {
    
  function initTabs(container) {
      const tabs = container.querySelectorAll('[role="tab"]');
      const panel = container.querySelector('[role="tabpanel"]');
      const contentScript = container.querySelector('[data-tabs-content]');
      
      if (!tabs.length || !panel || !contentScript) return;
      
      let contentData;
      try {
        contentData = JSON.parse(contentScript.textContent);
      } catch(e) {
        console.error('Erro ao parsear dados das tabs:', e);
        return;
      }
      
      const textColumn = panel.querySelector('.content-tabs-text');
      const mediaColumn = panel.querySelector('.content-tabs-media');
      
      if (!textColumn || !mediaColumn) return;
      
      function updateContent(blockId) {
        const blockData = contentData.find(b => b.id === blockId);
        if (!blockData) {
          console.warn('Block data não encontrado para ID:', blockId);
          return;
        }
        
        // Elementos de texto
        const titleEl = textColumn.querySelector('[data-content="title"]');
        const subtitleEl = textColumn.querySelector('[data-content="subtitle"]');
        const descEl = textColumn.querySelector('[data-content="description"]');
        const existingWrapper = mediaColumn.querySelector('.content-tabs-media-wrapper');
        
        // Fase 1: Fade out dos elementos atuais
        if (titleEl) titleEl.classList.add('fade-out');
        if (subtitleEl) subtitleEl.classList.add('fade-out');
        if (descEl) descEl.classList.add('fade-out');
        if (existingWrapper) existingWrapper.classList.add('fade-out');
        
        // Fase 2: Após fade out, atualiza conteúdo e faz fade in
        setTimeout(function() {
          // Atualiza título
          if (titleEl) {
            titleEl.textContent = blockData.title || '';
            titleEl.style.display = blockData.title ? '' : 'none';
            titleEl.classList.remove('fade-out');
            titleEl.classList.add('fade-in');
            setTimeout(function() {
              titleEl.classList.remove('fade-in');
            }, 400);
          }
          
          // Atualiza subtítulo
          if (subtitleEl) {
            subtitleEl.textContent = blockData.subtitle || '';
            subtitleEl.style.display = blockData.subtitle ? '' : 'none';
            subtitleEl.classList.remove('fade-out');
            subtitleEl.classList.add('fade-in');
            setTimeout(function() {
              subtitleEl.classList.remove('fade-in');
            }, 400);
          }
          
          // Atualiza descrição
          if (descEl) {
            descEl.innerHTML = blockData.description || '';
            descEl.style.display = blockData.description ? '' : 'none';
            descEl.classList.remove('fade-out');
            descEl.classList.add('fade-in');
            setTimeout(function() {
              descEl.classList.remove('fade-in');
            }, 400);
          }
          
          // Atualiza mídia
          const existingClasses = existingWrapper ? Array.from(existingWrapper.classList) : [];
          const existingBorderRadius = existingWrapper ? existingWrapper.style.borderRadius : '';
          
          if (existingWrapper) {
            existingWrapper.remove();
          }
          
          if (blockData.media_type === 'image' && blockData.media_image) {
            const imgWrapper = document.createElement('div');
            imgWrapper.className = 'content-tabs-media-wrapper fade-in';
            existingClasses.forEach(cls => {
              if (cls.startsWith('content-tabs-media--desktop-') || cls.startsWith('content-tabs-media--mobile-')) {
                imgWrapper.classList.add(cls);
              }
            });
            if (existingBorderRadius) {
              imgWrapper.style.borderRadius = existingBorderRadius;
            }
            
            const img = document.createElement('img');
            img.src = blockData.media_image;
            img.alt = blockData.media_alt || blockData.title || '';
            img.className = 'content-tabs-image';
            img.loading = 'lazy';
            
            imgWrapper.appendChild(img);
            mediaColumn.appendChild(imgWrapper);
            
            setTimeout(function() {
              imgWrapper.classList.remove('fade-in');
            }, 400);
          } else if (blockData.media_type === 'video' && blockData.media_video && blockData.media_video.mp4) {
            const videoWrapper = document.createElement('div');
            videoWrapper.className = 'content-tabs-media-wrapper fade-in';
            existingClasses.forEach(cls => {
              if (cls.startsWith('content-tabs-media--desktop-') || cls.startsWith('content-tabs-media--mobile-')) {
                videoWrapper.classList.add(cls);
              }
            });
            if (existingBorderRadius) {
              videoWrapper.style.borderRadius = existingBorderRadius;
            }
            
            const video = document.createElement('video');
            video.className = 'content-tabs-video';
            video.playsInline = true;
            if (blockData.media_video.preview) {
              video.poster = blockData.media_video.preview;
            }
            
            const source = document.createElement('source');
            source.src = blockData.media_video.mp4;
            source.type = blockData.media_video.mime_type || 'video/mp4';
            video.appendChild(source);
            
            videoWrapper.appendChild(video);
            mediaColumn.appendChild(videoWrapper);
            
            setTimeout(function() {
              videoWrapper.classList.remove('fade-in');
            }, 400);
          } else {
            // Imagem de exemplo quando a aba não tem mídia inserida
            const placeholderTemplate = container.querySelector('.content-tabs-media-placeholder-template');
            if (placeholderTemplate && placeholderTemplate.content) {
              const placeholderClone = placeholderTemplate.content.cloneNode(true);
              const wrapper = placeholderClone.querySelector('.content-tabs-media-wrapper');
              if (wrapper) {
                wrapper.classList.add('fade-in');
                if (existingBorderRadius) {
                  wrapper.style.borderRadius = existingBorderRadius;
                }
                mediaColumn.appendChild(placeholderClone);
                setTimeout(function() {
                  wrapper.classList.remove('fade-in');
                }, 400);
              }
            }
          }
        }, 300); // Aguarda fade out completar
      }
      
      tabs.forEach(function(tab) {
        tab.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const clickedTab = this;
          const blockId = clickedTab.getAttribute('data-tab');
          
          // Atualiza tabs
          tabs.forEach(function(t) {
            if (t === clickedTab) {
              t.classList.add('active');
              t.setAttribute('aria-selected', 'true');
            } else {
              t.classList.remove('active');
              t.setAttribute('aria-selected', 'false');
            }
          });
          
          // Atualiza conteúdo
          updateContent(blockId);
        };
      });
      
      // Setas do carrossel
      const arrows = container.querySelectorAll('.content-tabs-carousel-arrow');
      arrows.forEach(function(arrow) {
        arrow.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const isPrev = this.classList.contains('content-tabs-carousel-arrow--prev');
          const activeTab = container.querySelector('[role="tab"].active');
          if (!activeTab) return;
          
          const allTabs = Array.from(tabs);
          const currentIndex = allTabs.indexOf(activeTab);
          let targetTab;
          
          if (isPrev) {
            targetTab = currentIndex > 0 ? allTabs[currentIndex - 1] : allTabs[allTabs.length - 1];
          } else {
            targetTab = currentIndex < allTabs.length - 1 ? allTabs[currentIndex + 1] : allTabs[0];
          }
          
          if (targetTab) {
            targetTab.onclick(e);
          }
        };
      });
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    // Inicializar todas as seções
    document.querySelectorAll('[data-section-id]').forEach(initTabs);
  });
  
  // Reinitialize on section reload (Shopify theme editor)
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const container = event.target.querySelector('[data-section-id]');
      if (container) {
        initTabs(container);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jv-featured-collections-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SECTION_SELECTOR = '[data-testid="featured-collections-tabs"]';

    function scrollTabIntoView(tab, scroller) {
      if (!tab || !scroller) return;
      const tabLeft = tab.offsetLeft;
      const tabWidth = tab.offsetWidth;
      const scrollerWidth = scroller.clientWidth;
      const targetScroll = tabLeft - (scrollerWidth / 2) + (tabWidth / 2);
      scroller.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
    }

    function triggerCascade(section, panel) {
      if (section.dataset.cascadeEnabled !== 'true' || !panel) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const items = panel.querySelectorAll('.jv-fc-tabs__product-item');
      const initialDelay = Number(section.dataset.cascadeInitialDelay || 0);
      const stagger = Number(section.dataset.cascadeStagger || 80);

      items.forEach((item) => {
        item.classList.remove('jv-fc-cascade-visible');
        item.style.animationDelay = '';
        if (prefersReducedMotion) {
          item.style.opacity = '1';
          return;
        }
        item.style.opacity = '0';
      });

      if (prefersReducedMotion) return;

      items.forEach((item, index) => {
        const delay = initialDelay + index * stagger;
        item.style.animationDelay = delay + 'ms';
        window.setTimeout(() => {
          item.classList.add('jv-fc-cascade-visible');
        }, 10);
      });
    }

    function initFeaturedCollectionsTabs(section) {
      if (!section || section.dataset.fcTabsInit === 'true') return;
      section.dataset.fcTabsInit = 'true';

      const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
      const bannerPanels = Array.from(section.querySelectorAll('.jv-fc-tabs__banner-panel'));
      const productPanels = Array.from(section.querySelectorAll('.jv-fc-tabs__products-panel'));
      const scroller = section.querySelector('.jv-fc-tabs__tab-scroller');

      if (!tabs.length) return;

      function activateTab(selectedTab) {
        const targetId = selectedTab.dataset.tab;

        tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.classList.toggle('is-active', isSelected);
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.tabIndex = isSelected ? 0 : -1;
        });

        bannerPanels.forEach((panel) => {
          const isTarget = panel.dataset.panel === targetId;
          panel.classList.toggle('is-active', isTarget);
          panel.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
        });

        productPanels.forEach((panel) => {
          const isTarget = panel.dataset.panel === targetId;
          panel.classList.toggle('is-active', isTarget);
          panel.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
          if (isTarget) {
            triggerCascade(section, panel);
          }
        });

        scrollTabIntoView(selectedTab, scroller);
      }

      function handleKeyboard(event) {
        const currentIndex = tabs.indexOf(event.currentTarget);
        if (currentIndex < 0) return;

        let newIndex = currentIndex;

        switch (event.key) {
          case 'ArrowLeft':
            event.preventDefault();
            newIndex = currentIndex - 1 < 0 ? tabs.length - 1 : currentIndex - 1;
            break;
          case 'ArrowRight':
            event.preventDefault();
            newIndex = currentIndex + 1 >= tabs.length ? 0 : currentIndex + 1;
            break;
          case 'Home':
            event.preventDefault();
            newIndex = 0;
            break;
          case 'End':
            event.preventDefault();
            newIndex = tabs.length - 1;
            break;
          default:
            return;
        }

        tabs[newIndex].focus();
        activateTab(tabs[newIndex]);
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          activateTab(tab);
        });
        tab.addEventListener('keydown', handleKeyboard);
      });

      const activePanel = section.querySelector('.jv-fc-tabs__products-panel.is-active');
      triggerCascade(section, activePanel);
    }

    function initAll() {
      document.querySelectorAll(SECTION_SELECTOR).forEach(initFeaturedCollectionsTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector(SECTION_SELECTOR);
      if (section) {
        section.dataset.fcTabsInit = 'false';
        initFeaturedCollectionsTabs(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jv-parallax"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initContentCascade(content) {
      if (!content || content.dataset.contentAnimateInitialized === 'true') {
        return;
      }

      const items = content.querySelectorAll('.jv-parallax__content-item');
      if (!items.length) {
        return;
      }

      content.dataset.contentAnimateInitialized = 'true';

      const duration = Number(content.dataset.parallaxContentDuration || 600);
      const initialDelay = Number(content.dataset.parallaxContentDelay || 0);
      const stagger = Number(content.dataset.parallaxContentStagger || 120);

      if (reducedMotion) {
        items.forEach(function (item) {
          item.classList.add('is-visible');
        });
        return;
      }

      function revealItems() {
        items.forEach(function (item, index) {
          item.style.setProperty('--jv-parallax-content-duration', duration + 'ms');
          item.style.setProperty('--jv-parallax-content-delay', initialDelay + index * stagger + 'ms');
          item.classList.add('is-visible');
        });
      }

      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              revealItems();
              observer.disconnect();
            }
          });
        },
        { root: null, rootMargin: '50px', threshold: 0.1 }
      );

      observer.observe(content);
    }

    function initAll() {
      document.querySelectorAll('[data-parallax-content-animate]:not([data-content-animate-initialized="true"])').forEach(initContentCascade);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jv-product-list-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('[data-testid="product-list-tabs"]');
    
    sections.forEach(section => {
      const tabs = section.querySelectorAll('[role="tab"]');
      const panels = section.querySelectorAll('[role="tabpanel"]');
      
      const scrollContainer = section.querySelector('.product-tabs-scroll');
      const mobileTabsQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      function scrollTabIntoView(tab) {
        if (!scrollContainer || !mobileTabsQuery.matches) return;

        const tabLeft = tab.offsetLeft;
        const tabWidth = tab.offsetWidth;
        const containerWidth = scrollContainer.clientWidth;
        const targetScroll = tabLeft - containerWidth / 2 + tabWidth / 2;

        scrollContainer.scrollTo({
          left: Math.max(0, targetScroll),
          behavior: reducedMotionQuery.matches ? 'auto' : 'smooth',
        });
      }

      function refreshPanelCarousel(panel) {
        if (!panel) return;

        requestAnimationFrame(() => {
          const scroller = panel.querySelector('slideshow-slides');

          if (scroller) {
            scroller.scrollLeft = 0;
          }

          window.dispatchEvent(new Event('resize'));
        });
      }

      function switchTab(selectedTab) {
        const targetPanel = selectedTab.getAttribute('aria-controls');
        let activatedPanel = null;

        tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.setAttribute('aria-selected', isSelected);
          tab.classList.toggle('active', isSelected);
        });

        panels.forEach((panel) => {
          const isTarget = panel.id === targetPanel;

          if (isTarget) {
            panel.classList.add('active');
            activatedPanel = panel;
          } else {
            panel.classList.remove('active');
          }
        });

        refreshPanelCarousel(activatedPanel);
        scrollTabIntoView(selectedTab);
      }
      
      function handleKeyboard(e) {
        const tabsArray = Array.from(tabs);
        const currentIndex = tabsArray.indexOf(e.currentTarget);
        let newIndex;

        switch(e.key) {
          case 'ArrowLeft':
            e.preventDefault();
            newIndex = currentIndex - 1;
            if (newIndex < 0) newIndex = tabsArray.length - 1;
            tabsArray[newIndex].focus();
            switchTab(tabsArray[newIndex]);
            break;
          case 'ArrowRight':
            e.preventDefault();
            newIndex = currentIndex + 1;
            if (newIndex >= tabsArray.length) newIndex = 0;
            tabsArray[newIndex].focus();
            switchTab(tabsArray[newIndex]);
            break;
          case 'Home':
            e.preventDefault();
            tabsArray[0].focus();
            switchTab(tabsArray[0]);
            break;
          case 'End':
            e.preventDefault();
            tabsArray[tabsArray.length - 1].focus();
            switchTab(tabsArray[tabsArray.length - 1]);
            break;
        }
      }
      
      tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          switchTab(e.currentTarget);
        });
        tab.addEventListener('keydown', handleKeyboard);
      });

      const initialActiveTab = section.querySelector('[role="tab"].active');
      if (initialActiveTab) {
        scrollTabIntoView(initialActiveTab);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bottom-nav"] && !Shopify.designMode) return;
  try {
    
  class MobileBottomNav extends HTMLElement {
    connectedCallback() {
      this.isHidden = false;
      this.lastScrollY = window.scrollY;
      this.scrollThreshold = Number(this.dataset.scrollThreshold) || 12;
      this.hideOnScroll = this.dataset.hideOnScroll === 'true';
      this.hideWhenStickyVisible = true;
      this.ticking = false;
      this.enablePageTransition = this.dataset.enablePageTransition === 'true';

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });

      if (this.enablePageTransition) {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            this.classList.add('is-entered');
          });
        });
      }

      this.updateState();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }

    handleScroll() {
      if (this.ticking) return;

      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.updateState();
        this.ticking = false;
      });
    }

    handleResize() {
      this.updateState();
    }

    updateState() {
      const currentY = window.scrollY;
      const diff = currentY - this.lastScrollY;
      const stickyCartVisible = Boolean(document.querySelector('.product-sticky-cart.is-visible'));

      if (this.hideWhenStickyVisible && stickyCartVisible) {
        this.classList.add('is-covered-by-sticky');
      } else {
        this.classList.remove('is-covered-by-sticky');
      }

      if (!this.hideOnScroll) {
        this.classList.remove('is-hidden');
        this.lastScrollY = currentY;
        return;
      }

      if (Math.abs(diff) < this.scrollThreshold) {
        this.lastScrollY = currentY;
        return;
      }

      if (diff > 0 && currentY > 20) {
        this.classList.add('is-hidden');
      } else if (diff < 0) {
        this.classList.remove('is-hidden');
      }

      this.lastScrollY = currentY;
    }
  }

  if (!customElements.get('mobile-bottom-nav')) {
    customElements.define('mobile-bottom-nav', MobileBottomNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specifications"] && !Shopify.designMode) return;
  try {
    
    // Tooltip functionality
    document.addEventListener('DOMContentLoaded', function() {
      const infoButtons = document.querySelectorAll('.specification-block__info-button');
      
      infoButtons.forEach(button => {
        const tooltipId = button.dataset.tooltipId;
        const tooltip = document.getElementById(tooltipId);
        
        if (!tooltip) return;
        
        // Toggle tooltip on click
        button.addEventListener('click', function(e) {
          e.stopPropagation();
          
          // Close all other tooltips
          document.querySelectorAll('.specification-tooltip:not([hidden])').forEach(t => {
            if (t !== tooltip) {
              t.setAttribute('hidden', '');
            }
          });
          
          // Toggle this tooltip
          if (tooltip.hasAttribute('hidden')) {
            tooltip.removeAttribute('hidden');
          } else {
            tooltip.setAttribute('hidden', '');
          }
        });
        
        // Hover to show (optional)
        button.addEventListener('mouseenter', function() {
          tooltip.removeAttribute('hidden');
        });
        
        button.addEventListener('mouseleave', function() {
          // Small delay before hiding
          setTimeout(() => {
            if (!tooltip.matches(':hover')) {
              tooltip.setAttribute('hidden', '');
            }
          }, 100);
        });
        
        // Keep tooltip open when hovering over it
        tooltip.addEventListener('mouseenter', function() {
          tooltip.removeAttribute('hidden');
        });
        
        tooltip.addEventListener('mouseleave', function() {
          tooltip.setAttribute('hidden', '');
        });
      });
      
      // Close tooltips when clicking outside
      document.addEventListener('click', function(e) {
        if (!e.target.closest('.specification-block__info-wrapper')) {
          document.querySelectorAll('.specification-tooltip:not([hidden])').forEach(tooltip => {
            tooltip.setAttribute('hidden', '');
          });
        }
      });
      
      // Close on Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          document.querySelectorAll('.specification-tooltip:not([hidden])').forEach(tooltip => {
            tooltip.setAttribute('hidden', '');
          });
        }
      });
    });
  
  } catch(e) { console.error(e); }
})();
})();
